import { apiAxios } from "../../apiConfig";

export const getSurveys = async (params = {}) => {
  try {
    const response = await apiAxios.get("/surveys", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching surveys:", error);
    throw error;
  }
};

export const getSurveyStats = async () => {
  try {
    const response = await apiAxios.get("/surveys/stats");
    return response.data;
  } catch (error) {
    console.error("Error fetching survey stats:", error);
    throw error;
  }
};

export const deleteSurvey = async (id) => {
  try {
    const response = await apiAxios.delete(`/surveys/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting survey:", error);
    throw error;
  }
};
